import { scrollTo } from '../core/ScrollService.js';
import $ from 'jquery';
const initAnchors = () => {
    let anchor, anchorElt;

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener("click", (event) => {
            anchor = link.getAttribute('href').substring(1);
            if (anchor != '') {
                anchorElt = document.querySelector('[data-anchor="' + anchor + '"]');
                if (anchorElt) {
                    let offset = (anchorElt.getAttribute('data-anchor-offset')) ? parseInt(anchorElt.getAttribute('data-anchor-offset')) : 0;
                    scrollTo(anchorElt, offset);
                }
            }
        });
    });

    if (window.location.hash) {
        anchor = window.location.hash.substring(1);
        anchorElt = document.querySelector('[data-anchor="' + anchor + '"]');
        if (anchorElt) {
            setTimeout(() => {
                let offset = (anchorElt.getAttribute('data-anchor-offset')) ? parseInt(anchorElt.getAttribute('data-anchor-offset')) : 0;
                scrollTo(anchorElt, offset);
            }, 500);
        }
    }
};

export { initAnchors };
